import React from "react";
import {
  Heading,
  Text,
  VStack,
  Box,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Flex,
  UnorderedList,
  ListItem
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { IntroductionIcon } from "../../assets/icons";

const Introduction = () => {
  const { t } = useTranslation();

  return (
    <VStack spacing={6} align="start">
      <Flex align="center" mb={4}>
        <IntroductionIcon />
        <Heading as="h1" size="2xl" pl={2}>{t("reports.introduction.title")}</Heading>
      </Flex>

      <Accordion defaultIndex={[0]} allowMultiple width="100%">
        {/* Section 1: Welcome */}
        <AccordionItem>
          <AccordionButton>
            <Box flex="1" textAlign="left" fontWeight="bold">
              {t("reports.introduction.welcome_title")}
            </Box>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel>
            <Text mb={4}>{t("reports.introduction.welcome_text_1")}</Text>
            <Text mb={4}>{t("reports.introduction.welcome_text_2")}</Text>
            <Text mb={4}>{t("reports.introduction.welcome_text_3")}</Text>
          </AccordionPanel>
        </AccordionItem>
        
        {/* Section 2: Instructions */}
        <AccordionItem>
          <AccordionButton>
            <Box flex="1" textAlign="left" fontWeight="bold">
              {t("reports.introduction.results_title")}
            </Box>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel>
            <Text mb={4}>{t("reports.introduction.results_p1")}</Text>
            <UnorderedList>
              <ListItem>{t("reports.introduction.item_1")}</ListItem>
              <ListItem>{t("reports.introduction.item_2")}</ListItem>
              <ListItem>{t("reports.introduction.item_3")}</ListItem>
              <ListItem>{t("reports.introduction.item_4")}</ListItem>
              <ListItem>{t("reports.introduction.item_5")}</ListItem>
            </UnorderedList>
          </AccordionPanel>
        </AccordionItem>

        
      </Accordion>
    </VStack>
  );
};

export default Introduction;